import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "notifications",
      method: "get",
      params: args?.params,
      authorization: true,
      config: {
        showErr: args?.showErr ?? true,
      },
    };

    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    const response = await request(config);
    return response;
  } catch (error: any) {
    throw new Error(error);
  }
};

const markAsRead = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `notifications/${args?.id}/read`,
      method: "patch",
      authorization: true,
      config: {
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (error: any) {
    throw new Error(error);
  }
};

const markAllAsRead = async () => {
  try {
    const config: ReturnType = {
      url: "notifications/read-all",
      method: "patch",
      authorization: true,
      config: {
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (error: any) {
    throw new Error(error);
  }
};

export default { list, markAsRead, markAllAsRead };
